import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';

const ConnectWalletButton = () => {
    return (
        <div className="mt-10 flex justify-center">
            <ConnectButton
                accountStatus={{
                    smallScreen: 'avatar',
                    largeScreen: 'full',
                }}
                chainStatus={{
                    smallScreen: 'icon',
                    largeScreen: 'full',
                }}
                showBalance={false}
                label="Connect Wallet"
            />
        </div>
    );
};

export default ConnectWalletButton;
